<app-all-debtors-filter
    (geFilter)="receiveFilterGeneral($event)"
></app-all-debtors-filter>

<main>
    <app-all-debtors-table
        [recieveData]="deudores"
        [booleanFlag]="booleanFlag"
        [booleanText]="booleanText"
        (changePagination)="receiveProviderPaginationChange($event)"
        (changeSorting)="receiveChangeSortingOrder($event)"
        (actualizarData)="actualizarData($event)"
    ></app-all-debtors-table>
</main>